import React from 'react';
import { Info2 } from '@dbk/ui-icons';
import Popover from '@dbk/ui-popover';
import { BasicNumber } from '@dbk/ui-numbers';
import { IntlProvider } from '@dbk/format';
import Text from '@dbk/ui-text';
import SimpleDate from '../../../../../../../../../src/components/common/date';
import { ORDER_OBJECT_TYPE, NO_DATA, TEXT_SIZE } from '../constants';
import { PALETTE } from '../../../../../../../../../src/constants';
import { Currency } from '../../../../../../../../../src/components/common/number';
import largeText from './trade-object.styles';


const renderValue = (props) => {
  switch (props.type) {
    case ORDER_OBJECT_TYPE.CURRENCY:
      if (props.currency && props.value) {
        return (
          <Currency
            testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            renderProps={{ size: 'small', style: { color: PALETTE.secondaryActive} }}
            currencyDisplay="code"
            currency={props.currency}
            value={props.value}
          />
        )
      }
      return <Text>{NO_DATA}</Text>;

    case ORDER_OBJECT_TYPE.TEXT:
      return (
        <Text testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
        >{props.value && props.value.length > 0 ? props.value : NO_DATA}</Text>
      )

    case ORDER_OBJECT_TYPE.DATE:
      if (props.value && props.value.length > 0) {
        return (
          <SimpleDate
            value={props.value}
            testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
            renderProps={{size:"normal", type:'primary'}}
          />
        )
      }
      return <Text>{NO_DATA}</Text>;

    case ORDER_OBJECT_TYPE.NUMBER:
      if (props.value) {
        return (
          <IntlProvider locale={props.langCode}>
            <BasicNumber
              value={props.value}
              testID={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
              accessibilityLabel={`text_trade_tradeObject_${props.id ? props.id : ''}_test`}
              renderProps={{className: 'small'}}
            />
          </IntlProvider>
        )
      }
      return <Text>{NO_DATA}</Text>
    default:
      return <Text>{NO_DATA}</Text>
  }
}


const TradeObject = (props) => (
  <div className="trade-object">
    <div className='primary'>
      <Text secondary testID={`label_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`label_trade_tradeObject_${props.id ? props.id : ''}_test`}>
        {props.title && props.title}
      </Text>
      {props.popoverText &&
        <Popover
          mode="popup"
          orientation="top"
          position={10}
          testID={`popover_trade_tradeObject_${props.id ? props.id : ''}_test`}
          accessibilityLabel={`popover_trade_tradeObject_${props.id ? props.id : ''}_test`}
          popOverClassName="trade-popover"
          content={
            <div testID={`popover_text_trade_tradeObject_${props.id ? props.id : ''}_test`} accessibilityLabel={`popover_text_trade_tradeObject_${props.id ? props.id : ''}_test`}>
              <Text secondary>{props.popoverText}</Text>
            </div>
          }
        >
          <Info2 color="#999999" />
        </Popover>
      }
    </div>
    {renderValue(props)}
  </div>
)

export default TradeObject;

